import React from 'react';

import FixedHeader from '../../components/fixed-header/fixed-header';
import HeaderLogo from '../../components/header/header-logo/header-logo';

import styles from './external-user-layout.scss';

interface ExternalUserLayoutComponentProps {
  children: React.ReactNode;
}

export const ExternalUserLayout = ({
  children,
}: ExternalUserLayoutComponentProps) => {
  return (
    <div className="ltr">
      <FixedHeader>
        <div className={styles.headerContent}>
          <HeaderLogo />
        </div>
      </FixedHeader>

      <div className={styles.userContent}>{children}</div>
    </div>
  );
};
